<template>
	<div class="blog-post-meta">
		<span class="blog-post-meta-item">
			<svg class="blog-post-meta-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
				<path d="M8 2v4M16 2v4M3 10h18" />
				<rect x="3" y="4" width="18" height="18" rx="2" />
			</svg>
			{{ formattedDate }}
		</span>
		<span class="blog-post-meta-item">
			<svg class="blog-post-meta-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
				<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
				<circle cx="12" cy="7" r="4" />
			</svg>
			{{ author }}
		</span>
	</div>
</template>

<script setup>
import { computed } from "vue";
import { formatPostDate } from "@/components/blog/blogPosts";

const props = defineProps({
	date: {
		type: String,
		required: true,
	},
	author: {
		type: String,
		required: true,
	},
});

const formattedDate = computed(() => formatPostDate(props.date));
</script>

<style scoped>
.blog-post-meta {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.25rem 1rem;
	font-size: 0.75rem;
	color: #64748b;
}

.blog-post-meta-item {
	display: inline-flex;
	align-items: center;
	gap: 0.375rem;
}

.blog-post-meta-icon {
	width: 0.875rem;
	height: 0.875rem;
}

@media (min-width: 640px) {
	.blog-post-meta {
		font-size: 0.875rem;
	}
}
</style>